module.exports = __webpack_public_path__ + "static/img/5.349d2fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/5.png
// module id = RxVg
// module chunks = 1